<div class="container">
  <mat-icon svgIcon="mat:arrow_back" (click)="closeModal()"></mat-icon>
  <h1 class="text-center">{{"WORKOUT.WORKOUT-DETAIL.SWAP-EXERCISE" | translate}}</h1>
  <div class="main-exercise">
    <ion-thumbnail>
      <img [src]="environment.exercises+'/'+exercise._id+'/images/main'">
    </ion-thumbnail>
    <p class="exercise-name">{{exercise.i18nName[translate.currentLang.toUpperCase()]}}</p>
  </div>
  <div class="center-swap">
    <mat-icon svgIcon="mat:swap_vert"></mat-icon>
  </div>

  <div class="alternative-exercise">
    <ion-thumbnail>
      <img [class.ion-thumb-hidden]="showSpinner" [src]="environment.exercises+'/'+exerciseAlternative._id+'/images/main'">
      <div class="skeleton ex-alternative-spinner" *ngIf="showSpinner" style="border-radius: 8px;"></div>
    </ion-thumbnail>
    <p class="exercise-name">{{exerciseAlternative.i18nName[translate.currentLang.toUpperCase()]}}</p>
  </div>
  <button class="its-button" (click)="closeModal('confirm')">{{"GENERIC.CONFIRM" | translate}}</button>
</div>
